export const ENV = process.env.REACT_APP_Environment || process.env.REACT_APP_ENV;
export const NODE_ENV = process.env.NODE_ENV;
export const PUBLIC_URL = process.env.PUBLIC_URL;
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN;

export const IS_DEV = ENV === "development";
export const IS_STAGING = ENV === "staging";
export const IS_PREPROD = ENV === "preprodEnviroment" || ENV === "preprod";
export const IS_PROD = ENV === "prodEnviroment" || ENV === "prod";

export const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT;
export const DECRPTION_KEY_HEX = process.env.REACT_APP_DECRPTION_KEY_HEX;
export const GOOGLE_ID = process.env.REACT_APP_GOOGLE_ID;
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export const FIREBASE_API_KEY = process.env.REACT_APP_ApiKey;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_AuthDomain;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_ProjectId;
export const FIREBASE_STORAGE_BUCKET = process.env.REACT_APP_StorageBucket;
export const FIREBASE_MESSAGING_SENDER_ID = process.env.REACT_APP_MessagingSenderId;
export const FIREBASE_APP_ID = process.env.REACT_APP_AppId;
export const FIREBASE_MEASUREMENT_ID = process.env.REACT_APP_MeasurementId;

export const ENABLE_SMS = process.env.REACT_APP_ENABLE_SMS === "true";
